import { comboboxStyles as fastComboboxStyles } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const foundationComboboxStyles = (context, definition) => css `
  .combo-box-indicator {
    transition-property: transform;
    transition-duration: 0.2s;
    transition-timing-function: ease-out;
  }

  :host([open]) .combo-box-indicator {
    transform: rotate(180deg);
  }

  ${fastComboboxStyles(context, definition)}
`;
